export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SAVE_FILTER = "SAVE_FILTER";
export const SAVE_PAGE = "SAVE_PAGE";